<template>
  <div class="full virtual-map-info" style="height: 100%;">
    <el-row type="flex" justify="space-between" class="mr-b15" style="border-bottom: 1px solid #e0e0e0;">
      <div>
        <div class="title-bar" style="height: 43px; margin: 0 !important">
          <h3>[ {{getEmptyText(selectedParams.objtypeName)}} ] {{getEmptyText(selectedParams.label)}}</h3>
        </div>
      </div>
      <el-button style="color: #808589; margin-top: 2px; padding: 10px !important;" type="no-border" size="large" @click="closeSecondScreenBtnClick">
        <i class="el-dialog__close el-icon el-icon-close" style="font-size: 20px; line-height: 20px;"></i>
      </el-button>
    </el-row>
    <el-scrollbar class="timeline" style="height: calc(100% - 108px);">
      <div style="height: 100%;">
        <el-row type="flex" style="height: 160px;">
          <w-virtual-map-info-config :selected-params = "selectedParams"></w-virtual-map-info-config>
        </el-row>
        <div class="mr-b30" style="height: 200px">
          <el-row v-if="selectedParams.objtypeId === 'VCL'" type="flex" justify="center">
            <el-col :span="12" style="width: 150px; height: 200px; margin-right: 10px;">
              <w-virtual-map-pie-chart ref="vclCpu" :title="CPU_USERATE_DEFINE"></w-virtual-map-pie-chart>
            </el-col>
            <el-col :span="12" style="width: 150px; height: 200px;">
              <w-virtual-map-pie-chart ref="vclMem" :title="MEM_USERATE_DEFINE"></w-virtual-map-pie-chart>
            </el-col>
          </el-row>
          <el-row v-else-if="selectedParams.objtypeId === 'VHO'" type="flex" justify="center">
            <el-col :span="12" style="width: 150px; height: 200px; margin-right: 10px;">
              <w-virtual-map-pie-chart ref="vhoCpu" :title="CPU_USERATE_DEFINE"></w-virtual-map-pie-chart>
            </el-col>
            <el-col :span="12" style="width: 150px; height: 200px;">
              <w-virtual-map-pie-chart ref="vhoMem" :title="MEM_USERATE_DEFINE"></w-virtual-map-pie-chart>
            </el-col>
          </el-row>
          <el-row v-else-if="selectedParams.objtypeId === 'VVM'" type="flex" justify="center">
            <el-col :span="8" style="width: 150px; height: 200px;">
              <w-virtual-map-pie-chart ref="vvmCpu" :title="CPU_USERATE_DEFINE"></w-virtual-map-pie-chart>
            </el-col>
            <el-col :span="8" style="width: 150px; height: 200px;">
              <w-virtual-map-pie-chart ref="vvmMem" :title="MEM_USERATE_DEFINE"></w-virtual-map-pie-chart>
            </el-col>
            <el-col :span="8" style="width: 150px; height: 200px;">
              <w-virtual-map-pie-chart ref="vvmDisk" :title="DISK_USERATE_DEFINE"></w-virtual-map-pie-chart>
            </el-col>
          </el-row>
          <el-row v-else-if="selectedParams.objtypeId === 'VDSC'" type="flex" justify="center">
            <el-col :span="24" style="width: 150px; height: 200px;">
              <w-virtual-map-pie-chart ref="vdscStorage" :title="STORAGE_USERATE_DEFINE"></w-virtual-map-pie-chart>
            </el-col>
          </el-row>
          <el-row v-else-if="selectedParams.objtypeId === 'VDS'" type="flex" justify="center">
            <el-col :span="24" style="width: 150px; height: 200px;">
              <w-virtual-map-pie-chart ref="vdsStorage" :title="STORAGE_USERATE_DEFINE"></w-virtual-map-pie-chart>
            </el-col>
          </el-row>
        </div>
        <el-row type="flex">
          <el-table-wrapper :column-default="columnDefault" :data="tableData" :columns="tableColumn" :pagination="false"
            ref="eventTable" style="width:100%;">
            <template slot-scope="scope" slot="eventlevel-slot">
              <w-eventlevel-cell mini :eventlevel-id="scope.row.eventlevelId" />
            </template>
            <template slot-scope="scope" slot="event-message-slot">
              <div v-if="scope.row.dynamicThresholdFlag === 'Y'" class="round-box-info-text red">
                동적
              </div>
              <span class="link c-pointer" @click="clickEventMessage(scope.row)">{{scope.row.eventMessage}}</span>
            </template>
          </el-table-wrapper>
        </el-row>
      </div>
    </el-scrollbar>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { columnDefault } from '@/constants/table';
import { getDateToString } from '@/utils/date';
import { isNil, forEach, camelCase } from 'lodash';
import { EMPTY_TEXT } from '@/utils/string';
import { isEmpty } from '@/utils/basic';
import { convertValuByUnit } from '@/utils/number';
import { openFaultAnalysisPopup } from '@/utils/event';
import { treeType } from '@/constants/tree';
import VirtualMapApi from '@/api/virtual/performance/virtualmap';
import WEventlevelCell from '@/components/table/EventlevelCell';
import WVirtualMapInfoConfig from './VirtualMapInfoConfig';
import WVirtualMapPieChart from './VirtualMapPieChart';

// 각 objtypeId별 자원 정의
const VCL_RSC_DEFINE = [{ rsctypeId: 'VCL_CPU', rscId: 'USERATE', rscKey: '_' }, { rsctypeId: 'VCL_MEM', rscId: 'USERATE', rscKey: '_' }];
const VHO_RSC_DEFINE = [{ rsctypeId: 'VHO_CPU', rscId: 'USERATE', rscKey: '_' }, { rsctypeId: 'VHO_MEM', rscId: 'USERATE', rscKey: '_' }];
const VVM_RSC_DEFINE = [{ rsctypeId: 'VVM_CPU', rscId: 'USERATE', rscKey: '_' }, { rsctypeId: 'VVM_MEM', rscId: 'USERATE', rscKey: '_' }, { rsctypeId: 'VVM_DISK', rscId: 'USERATE', rscKey: '_' }];
const VDSC_RSC_DEFINE = [{ rsctypeId: 'VDSC_STORAGE', rscId: 'USERATE', rscKey: '_' }];
const VDS_RSC_DEFINE = [{ rsctypeId: 'VDS_STORAGE', rscId: 'USERATE', rscKey: '_' }];

// 자원명 정의
const CPU_USERATE_DEFINE = 'CPU 사용률';
const MEM_USERATE_DEFINE = '메모리 사용률';
const DISK_USERATE_DEFINE = '디스크 사용률';
const STORAGE_USERATE_DEFINE = '사용률';

export default {
  name: 'WVirtualMapInfo',
  components: {
    WVirtualMapInfoConfig,
    WEventlevelCell,
    WVirtualMapPieChart,
  },
  props: {
    selectedParams: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    ...mapGetters(['analysisDateParams']),
  },
  watch: {
    selectedParams: {
      handler() {
        if (this.selectedParams.objtypeId === 'VCL') {
          this.perfParams.rscInfoList = VCL_RSC_DEFINE;
        } else if (this.selectedParams.objtypeId === 'VHO') {
          this.perfParams.rscInfoList = VHO_RSC_DEFINE;
        } else if (this.selectedParams.objtypeId === 'VVM') {
          this.perfParams.rscInfoList = VVM_RSC_DEFINE;
        } else if (this.selectedParams.objtypeId === 'VDSC') {
          this.perfParams.rscInfoList = VDSC_RSC_DEFINE;
        } else if (this.selectedParams.objtypeId === 'VDS') {
          this.perfParams.rscInfoList = VDS_RSC_DEFINE;
        }
        this.perfParams.objIds = [this.selectedParams.objId];
        this.perfParams.managetypeKey = this.selectedParams.objtypeId;
        this.$nextTick(() => {
          this.loadData();
        });
      },
      immediate: true,
    },
  },
  data() {
    return {
      CPU_USERATE_DEFINE,
      MEM_USERATE_DEFINE,
      DISK_USERATE_DEFINE,
      STORAGE_USERATE_DEFINE,
      chartType: 'pie',
      perfParams: {
        limit: 10,
        managetypeId: 'VMS',
        managetypeKey: '',
        objIds: '',
        rscInfoList: [],
        selectedType: 'OBJ',
      },
      pieData: [],
      columnDefault,
      tableData: [],
      tableColumn: [
        {
          prop: 'eventlevelId',
          label: '등급',
          key: 'eventlevelId',
          scopedSlot: 'eventlevel-slot',
          headerAlign: 'center',
          columnKey: 'eventlevelId',
          className: 'eventlevel',
          width: 70,
        },
        {
          prop: 'objName',
          label: '대상',
          key: 'objName',
          headerAlign: 'center',
          width: 100,
        },
        {
          prop: 'eventMessage',
          label: '장애메시지',
          key: 'eventMessage',
          headerAlign: 'center',
          scopedSlot: 'event-message-slot',
        },
        {
          prop: 'checkDatetime',
          label: '최초발생시각',
          headerAlign: 'center',
          width: 140,
          formatter: this.getDateFormatter,
        },
      ],
      customLegendOptions: {
        width: 105,
        itemStyle: {
          fontSize: '10.5px',
          lineHeight: '17.5px',
        },
        symbolWidth: 6,
        symbolHeight: 6,
      },
    };
  },
  methods: {
    loadData() {
      // 장비 이벤트 조회
      VirtualMapApi.getEventStatusListForVirtualMap({ objId: this.selectedParams.objId }).then((res) => {
        if (res.data.success) {
          this.tableData = res.data.data;
        }
      });

      // 장비 성능정보 조회
      VirtualMapApi.getOrderNRscRslt(this.perfParams).then((res) => {
        if (res.data.success) {
          // 파이형태의 데이터 가공
          forEach(res.data.data, (data) => {
            if (isNil(data.value)) {
              data.value = 0;
            }
            this.pieData = [];
            this.pieData.push(data);
            this.$refs[camelCase(data.rsctypeId)].setData(this.makeChartData(this.pieData, 'OBJ'), this.selectedParams.objtypeId);
          });
        }
      });
    },
    getDateFormatter(row, column, value) {
      if (!isNil(value)) {
        return getDateToString(value);
      }
      return EMPTY_TEXT;
    },
    getEmptyText(value) {
      if (!isNil(value) && value !== '') {
        return value;
      }
      return EMPTY_TEXT;
    },
    closeSecondScreenBtnClick() {
      this.$emit('change-show-timeline-flag', true);
    },
    makeChartData(data, type) {
      let chartData = [];
      if (type === 'SQL') {
        const item = data[0];
        if (item.queryResultType === 'DOUBLE') {
          chartData = [
            {
              label: '',
              value: item.queryResultValue,
              unit: null,
              objId: null,
            },
          ];
        } else {
          const queryResultValue = JSON.parse(item.queryResultValue);
          queryResultValue.forEach((v) => {
            v.convertValue = convertValuByUnit(Number(v.value), v.unit, true);
            v.y = isEmpty(v.value) ? null : Number(v.value);
            v.name = isEmpty(v.label) ? ' ' : v.label;
          });
          chartData = queryResultValue;
        }
      } else {
        if (!isEmpty(data)) {
          data.forEach((item) => {
            item.convertValue = convertValuByUnit(Number(item.value), item.unit, true);
            item.y = isEmpty(item.value) ? null : Number(item.value);
            // item.y = isEmpty(item.value) ? 0 : Number(item.value);
            item.name = isEmpty(item.label) ? ' ' : item.label;
          });
        }
        chartData = data;
      }
      return chartData;
    },
    clickEventMessage(row) {
      openFaultAnalysisPopup(row.seqNumber);
    },
  },
};
</script>

<style lang="scss" scoped>
.virtual-map-info {
  margin-left: -22px;
}
</style>



// WEBPACK FOOTER //
// src/views/performance/components/virtual/VirtualMapInfo.vue